export default {

    /**
     * 跳转页面
     * @param string pagePath 页面路径
    */
    skip(pagePath) {
        this.$router.push(pagePath);
    }

}